import { render, staticRenderFns } from "./detailTab.vue?vue&type=template&id=24154632&scoped=true"
import script from "./detailTab.vue?vue&type=script&lang=js"
export * from "./detailTab.vue?vue&type=script&lang=js"
import style0 from "./detailTab.vue?vue&type=style&index=0&id=24154632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24154632",
  null
  
)

export default component.exports